import Clipboard from '../mixins/Clipboard'

const ClipboardPlugin = {
  install(Vue, options) {
    Vue.mixin(Clipboard)
  }
}

export default ClipboardPlugin
